export default {
  data() {
    return {
      customerName: '',
      logState: [
        { value: null, label: '全部' },
        { value: 1, label: '新增资料' },
        { value: 2, label: '变更基础资料' },
        { value: 4, label: '导入资料' },
        { value: 6, label: '变更等级' },
      ],
      timeList: [],
      tableData: [],
      tableLoading: false,
      fullscreenLoading: false,
    }
  },
  created() {
    this.page.objectGuid = this.$route.query.customerGuid;
    this.customerName = this.$route.query.customerName;
    this.getData({ timeList: [], flg: 1 });
  },
  methods: {
    // 查询变更列表
    getData(param) {
      if (param) {
        let { flg, timeList } = param;
        if (timeList) this.timeList = timeList;
        if (flg) this.page.pageIndex = 1;
      }
      if (this.timeList && this.timeList.length > 0) {
        this.page.updateTimeStart = this.timeList[0];
        this.page.updateTimeEnd = this.timeList[1];
      }
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msConfigureService}/data-alter/audit/get-list`, this.page).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.fullscreenLoading = false;
          if (res.data.data.records && res.data.data.records.length > 0) {
            this.tableData = res.data.data.records;
          } else {
            this.tableData = [];
          }
          this.page.totalPage = res.data.data.totalPages;
          this.page.totalRows = res.data.data.totalRows;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
  },
}